module.exports = __webpack_public_path__ + "front/img/d2.034e7766.png";